import { render, staticRenderFns } from "./ChipAddRemove.vue?vue&type=template&id=e0a891fa&"
import script from "./ChipAddRemove.vue?vue&type=script&lang=js&"
export * from "./ChipAddRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports